import React from "react";
import SelectOption from "./components/SelectOption";

const colatileComponentOptions = [
  {
    value: "含まない",
    label: "含まない",
  },
  {
    value: "含む",
    label: "含む",
  },
];

function SelectVolatileComponents(props) {
  const { selectedValue, onSelect, isReadonly } = props;

  return (
    <div className="w-full h-full border border-solid border-[#B3B3B3] bg-white rounded-[10px]">
      <div className="w-full h-full flex flex-col gap-2.5 p-2">
        <SelectOption
          label={colatileComponentOptions[0].label}
          value={colatileComponentOptions[0].value}
          onSelect={onSelect}
          isSelected={selectedValue === colatileComponentOptions[0].value}
          isReadonly={isReadonly}
          width="123px"
        />
        <SelectOption
          label={colatileComponentOptions[1].label}
          value={colatileComponentOptions[1].value}
          onSelect={onSelect}
          isSelected={selectedValue === colatileComponentOptions[1].value}
          isReadonly={isReadonly}
          width="123px"
          note={'※成分名・各配合量のご記載をお願いします。'}
        />
      </div>
    </div>
  );
}

export default SelectVolatileComponents;
